import * as stylex from "@stylexjs/stylex";
import {
  spacing,
  colors,
  fonts,
  fontSizes,
} from "@softmax/design-system/tokens.stylex";

import type { Position } from "./play-diagram-records";

export function Caption({
  at,
  lead,
  sub,
}: {
  readonly at: Position;
  readonly lead: string;
  readonly sub: string | null;
}) {
  return (
    <div {...stylex.props(styles.caption, captionPlacement[at])}>
      <p data-caption-lead="true" {...stylex.props(styles.captionLead)}>
        {lead}
      </p>
      {sub ? (
        <p data-caption-sub="true" {...stylex.props(styles.captionSub)}>
          {sub}
        </p>
      ) : null}
    </div>
  );
}

const captionPlacement = stylex.create({
  card: {
    gridColumnStart: { default: "auto", "@container (min-width: 560px)": 1 },
    gridRowStart: { default: "auto", "@container (min-width: 560px)": 2 },
  },
  board: {
    gridColumnStart: { default: "auto", "@container (min-width: 560px)": 3 },
    gridRowStart: { default: "auto", "@container (min-width: 560px)": 2 },
  },
  standings: {
    gridColumnStart: { default: "auto", "@container (min-width: 560px)": 5 },
    gridRowStart: { default: "auto", "@container (min-width: 560px)": 2 },
  },
});

const styles = stylex.create({
  caption: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    gap: spacing.space2,
    paddingTop: {
      default: spacing.space6,
      "@container (min-width: 560px)": spacing.space10,
    },
    textAlign: "center",
  },
  captionLead: {
    margin: 0,
    width: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontFamily: fonts.mono,
    fontSize: fontSizes.body,
    lineHeight: "20px",
    color: colors.foreground,
  },
  captionSub: {
    margin: 0,
    width: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontFamily: fonts.sans,
    fontSize: fontSizes.caption,
    lineHeight: "15px",
    color: colors.secondary,
  },
});
